import { gql } from '@apollo/client';

import { REPORT_COMMON_FIELDS } from '../fragments/reportCommonFields';
import { STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS } from '../fragments/standardDeliveryDeviceHigherCategoryReportFilters';

export const CREATE_STANDARD_DELIVERY_DHC_REPORT = gql`
  mutation CreateStandardDeliveryDeviceHigherCategoryReport($report: ReportInput!, $filters: StandardDeliveryDeviceHigherCategoryReportFiltersInput!) {
      createStandardDeliveryDeviceHigherCategoryReport(report: $report, filters: $filters) {
      ...reportCommonFields
      filters {
        ...standardDeliveryDeviceHigherCategoryReportFilters
      }
    }
  }
  ${REPORT_COMMON_FIELDS},
  ${STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS}
`;
